import React from 'react'
import { useIntl } from 'react-intl'
interface FundingDropdownProps {
    sliderData: {
        id: number
        name: string
        type: 'securityClass' | 'scenario'
        isPresent: boolean
        currentValuations: number
    }[]
    setClassIds: (classIds: string[]) => void
    setScenarioIds: (scenarioIds: string[]) => void
    classIds: string[]
    scenarioIds: string[]
}


const FundingDropdown: React.FC<FundingDropdownProps> = ({
    sliderData,
    setClassIds,
    classIds,
    setScenarioIds,
    scenarioIds,
}: FundingDropdownProps) => {

    const { formatMessage } = useIntl()

    return (
        <div className='my-4'>
            <div className="accordion" id="accordionExample">
                <div className="accordion-item">
                    <h2 className="accordion-header">
                        <button className="accordion-button captable-accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                            <h4 className='text-success m-0'>{formatMessage({ id: 'Series A' })}</h4>
                        </button>
                    </h2>
                    <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                            <table className="table">
                                {/* <thead>
                                    <tr>
                                        <th className='font-size-16 fw-bold' scope="col">
                                            {formatMessage({ id: 'Funding' })}
                                        </th>
                                        <th className='font-size-16 fw-bold' scope="col">
                                            {formatMessage({ id: 'State' })}
                                        </th>
                                    </tr>
                                </thead> */}
                                <tbody>
                                    <>
                                        {sliderData.map((item: any, index: number) => (
                                            <tr>
                                                <td className='text-muted'>
                                                    {formatMessage({ id: item.name })}
                                                </td>
                                                <td style={{ color: item.isPresent ? '#28a745' : '#b0b0b0' }}>
                                                    {/* {formatMessage({ id: 'Initial' })} */}
                                                    {item.isPresent ? 'Present' : item.type === 'securityClass' ? 'Share Class' : 'Scenario'}
                                                </td>
                                            </tr>
                                        ))}
                                        {/* <tr>
                                            <td className='text-muted'>
                                                {formatMessage({ id: 'Initial Funding' })}
                                            </td>
                                            <td>
                                                {formatMessage({ id: 'Initial' })}
                                            </td>
                                        </tr> */}
                                        {/* <tr>
                                            <td className='text-primary'>
                                                {formatMessage({ id: 'Seed Round 2' })}
                                            </td>
                                            <td>
                                                {formatMessage({ id: 'Past' })}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='text-success'>
                                                {formatMessage({ id: 'Series A' })}
                                            </td>
                                            <td>
                                                {formatMessage({ id: 'Present(Active)' })}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='text-warning'>
                                                {formatMessage({ id: 'Series A' })}
                                            </td>
                                            <td>
                                                {formatMessage({ id: 'Scenario' })}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='text-warning'>
                                                {formatMessage({ id: 'Series B' })}
                                            </td>
                                            <td>
                                                {formatMessage({ id: 'Scenario' })}
                                            </td>
                                        </tr> */}
                                    </>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FundingDropdown
